// Includes only the "core" of graphlib

import { Graph } from './graph.js';

const version = '2.1.9-pre';

export { Graph, version };
